/**
 * InfoTooltip Component
 * Question mark icon with tooltip
 * Used for inline help text
 */

import React from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { colors } from '../../theme/designTokens';

/**
 * InfoTooltip Component
 *
 * @param {string|ReactNode} content - Tooltip content
 * @param {string} icon - Icon type ('question' | 'info')
 * @param {string} placement - Tooltip placement (default: 'top')
 * @param {string} color - Icon color (default: neutral gray)
 * @param {Object} style - Additional styles
 */
function InfoTooltip({
  content,
  icon = 'question',
  placement = 'top',
  color = colors.neutral[500],
  style = {},
}) {
  const Icon = icon === 'info' ? InfoCircleOutlined : QuestionCircleOutlined;

  return (
    <Tooltip title={content} placement={placement}>
      <Icon
        style={{
          color,
          fontSize: 14,
          marginLeft: 4,
          cursor: 'help',
          ...style,
        }}
      />
    </Tooltip>
  );
}

export default InfoTooltip;
